import { render, staticRenderFns } from "./TypeModal.vue?vue&type=template&id=7aaca7d8&scoped=true&"
import script from "./TypeModal.vue?vue&type=script&lang=js&"
export * from "./TypeModal.vue?vue&type=script&lang=js&"
import style0 from "./TypeModal.vue?vue&type=style&index=0&id=7aaca7d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aaca7d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7aaca7d8')) {
      api.createRecord('7aaca7d8', component.options)
    } else {
      api.reload('7aaca7d8', component.options)
    }
    module.hot.accept("./TypeModal.vue?vue&type=template&id=7aaca7d8&scoped=true&", function () {
      api.rerender('7aaca7d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/references/uniform/modals/TypeModal.vue"
export default component.exports